import _defineProperty from '@babel/runtime/helpers/defineProperty';

class OmniscentRandom {
  constructor() {
    _defineProperty(this, "randomA", 0);
    _defineProperty(this, "randomB", 0);
    this.reset();
  }
  reset() {
    this.randomA = 0x08088405;
    this.randomB = 0x000010FB;
  }
  random(x) {
    this.randomB = Math.imul(this.randomB, this.randomA) + 1 | 0;
    return (this.randomB >> 16 & 0xFFFF) * x >> 16 & 0xFFFF;
  }
}

export { OmniscentRandom };
//# sourceMappingURL=OmniscentRandom.mjs.map
